import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatBadgeModule } from '@angular/material/badge';

@NgModule({
  declarations: [],
  imports: [
    MatCardModule,
    MatToolbarModule,
    MatBadgeModule
  ],
  exports: [
    MatCardModule,
    MatToolbarModule,
    MatBadgeModule
  ]
})
export class MaterialModule { }
